import { render, staticRenderFns } from "./ArchiveXLS.vue?vue&type=template&id=7833b8b6&"
import script from "./ArchiveXLS.vue?vue&type=script&lang=ts&"
export * from "./ArchiveXLS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports